import React from "react";

export default function FiscalOutChecks({ operationType, movement, value, onChange }) {
  if (movement !== "Egreso" || !["FiscalImpo", "FiscalExpo"].includes(operationType)) return null;
  return (
    <div className="operation-out-checks" role="group" aria-label="Controles de salida">
      {[["siel", "SIEL"], ["facturacion", "Facturación"]].map(([field, label]) => (
        <label key={field}>
          <input type="checkbox" checked={!!value[field]}
            onChange={(event) => onChange(field, event.target.checked)} />
          {label}
        </label>
      ))}
    </div>
  );
}
